export const choreApproveTranslateEn = {
    APPROVE_AND_PAY:{
        PAY_FLOW:{
          PAY_DESCRIPTION_PART_1: "Awesome! The",
          PAY_DESCRIPTION_PART_2: "reward for the chore has been transferred to",
          PAY_DESCRIPTION_PART_3: "’s account",
          ADD_NEW_CHORE_BUTTON:"Add new chore",
          GO_TO_HOME_BUTTON:"Go to your home page",
          LABEL_PAY:"Isn’t that magical?"
        },
        NOT_ENOUGH_FUNDS:{
          DESCRIPTION: "Whoops! It seems you don’t have enough funds in your account.",
          FUND_ACCOUNT_BUTTON: "Fund account",
          PAY_LAYER_BUTTON: "Pay later",
          ERROR:{
            DESCRIPTION:"We ran into a problem with our service. Please try again later.",
            BUTTON:"Pay later"
          }
        }
      },
}